(() => {
  'use strict';
  const active = new WeakMap();
  function init(ticket) {
    if (active.has(ticket)) return;
    const canvas=ticket.querySelector('canvas'),cover=ticket.querySelector('[data-vb-scratch-cover]');
    const button=ticket.querySelector('[data-vb-scratch-reveal]'),status=ticket.querySelector('[data-vb-scratch-status]');
    const content=ticket.querySelector('[data-vb-scratch-content]');
    if(!canvas||!cover||!button||!content)return;
    let ctx;
    try{ctx=canvas.getContext('2d');}catch{return;}
    if(!ctx)return;
    const initialButtonLabel=button.textContent;
    const initialContentTabIndex=content.getAttribute('tabindex');
    let revealed=false,pointer=null,last=null,width=0,height=0,frame=0;
    const strokes=[],cells=new Set(),listeners=[];
    const listen=(node,event,fn)=>{node.addEventListener(event,fn);listeners.push(()=>node.removeEventListener(event,fn));};
    function release(){
      if(pointer!==null && canvas.hasPointerCapture?.(pointer))canvas.releasePointerCapture(pointer);
      pointer=null;last=null;
    }
    function reveal(){
      if(revealed)return;revealed=true;release();
      ticket.classList.add('is-revealed');cover.setAttribute('aria-hidden','true');
      content.removeAttribute('aria-hidden');status.textContent=ticket.dataset.revealedLabel;
      button.textContent=ticket.dataset.revealedLabel;button.disabled=true;
      if(document.activeElement===button){content.setAttribute('tabindex','-1');content.focus({preventScroll:true});}
    }
    function erase(a,b,radius){
      ctx.globalCompositeOperation='destination-out';ctx.globalAlpha=1;ctx.strokeStyle='#000';ctx.fillStyle='#000';ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=radius*2;
      ctx.beginPath();ctx.moveTo(a.x*width,a.y*height);ctx.lineTo(b.x*width,b.y*height);ctx.stroke();
      ctx.beginPath();ctx.arc(b.x*width,b.y*height,radius,0,Math.PI*2);ctx.fill();
      ctx.globalCompositeOperation='source-over';
    }
    function paint(){
      frame=0;if(revealed)return;
      const rect=cover.getBoundingClientRect();if(rect.width<=0||rect.height<=0)return;
      width=rect.width;height=rect.height;
      const ratio=Math.min(window.devicePixelRatio||1,2);
      canvas.width=Math.round(width*ratio);canvas.height=Math.round(height*ratio);ctx.setTransform(ratio,0,0,ratio,0,0);
      const foil=ctx.createLinearGradient(0,0,width,height*.55);
      [[0,'#ae7669'],[.14,'#e6b29d'],[.29,'#fae3cc'],[.43,'#c98b7b'],[.55,'#eab69e'],[.7,'#fff0db'],[.85,'#d6a089'],[1,'#b27a6b']].forEach(([p,c])=>foil.addColorStop(p,c));
      ctx.fillStyle=foil;ctx.fillRect(0,0,width,height);
      const light=ctx.createRadialGradient(width*.66,-height*.8,0,width*.66,-height*.8,height*1.8);
      light.addColorStop(0,'rgba(255,255,255,.45)');light.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=light;ctx.fillRect(0,0,width,height);
      for(const stroke of strokes)erase(stroke.a,stroke.b,Math.max(23,width*.075));
    }
    function position(e){const r=canvas.getBoundingClientRect();return {x:Math.max(0,Math.min(1,(e.clientX-r.left)/r.width)),y:Math.max(0,Math.min(1,(e.clientY-r.top)/r.height))};}
    function scratch(a,b){
      const radius=Math.max(23,width*.075);strokes.push({a,b});erase(a,b,radius);
      // Coverage comes from unique spatial cells; repeated rubbing cannot inflate it.
      const steps=Math.max(1,Math.ceil(Math.hypot((b.x-a.x)*width,(b.y-a.y)*height)/(radius/3)));
      for(let s=0;s<=steps;s++){
        const x=(a.x+(b.x-a.x)*s/steps)*width,y=(a.y+(b.y-a.y)*s/steps)*height;
        for(let row=0;row<24;row++)for(let col=0;col<40;col++){
          if(Math.hypot((col+.5)*width/40-x,(row+.5)*height/24-y)<=radius)cells.add(row*40+col);
        }
      }
      ticket.classList.add('is-scratching');
      if(cells.size/(40*24)>=.3)reveal();
    }
    listen(canvas,'pointerdown',e=>{if(revealed || pointer!==null || (e.pointerType==='mouse'&&e.button!==0))return;pointer=e.pointerId;canvas.setPointerCapture?.(pointer);last=position(e);scratch(last,last);});
    listen(canvas,'pointermove',e=>{if(pointer!==e.pointerId||revealed)return;const next=position(e);scratch(last,next);last=next;});
    listen(canvas,'pointerup',release);listen(canvas,'pointercancel',release);listen(canvas,'lostpointercapture',()=>{pointer=null;last=null;});
    listen(button,'click',reveal);
    const product=ticket.closest('[data-vb-product]');
    if(product)listen(product,'change',e=>{if(e.target.matches('[data-vb-variant]'))release();});
    let observer;
    const resize=()=>{release();if(!frame&&!revealed)frame=requestAnimationFrame(paint);};
    if(window.ResizeObserver){observer=new ResizeObserver(resize);observer.observe(cover);}else listen(window,'resize',resize);
    ticket.classList.add('vb-scratch-ready');
    paint();content.setAttribute('aria-hidden','true');
    active.set(ticket,()=>{release();observer?.disconnect();cancelAnimationFrame(frame);listeners.forEach(off=>off());content.removeAttribute('aria-hidden');if(initialContentTabIndex===null)content.removeAttribute('tabindex');else content.setAttribute('tabindex',initialContentTabIndex);button.disabled=false;button.textContent=initialButtonLabel;status.textContent='';ticket.classList.remove('vb-scratch-ready','is-scratching','is-revealed');active.delete(ticket);});
  }
  function boot(scope=document){scope.querySelectorAll('[data-vb-scratch]').forEach(init);}
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-vb-scratch]').forEach(node=>active.get(node)?.()));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
})();

